import classNames from "classnames";

import AscActivitiesFactory from "../AscActivitiesFactory/AscActivitiesFactory";
import AscSelectInput from "../../../AscInputFields/AscSelectInput/AscSelectInput";

import styles from "./AscAddActivity.module.scss";
import {
  ACTIVITY_ATTEMPTS_OPTIONS,
  ActivityAttemptsSelectOptions,
  ActivityTypeSelectOptions,
} from "@ascendnow/shared";
import { useAscAddModuleActivitiesForm } from "../useAscAddModuleActivitiesForm";
import { useMemo } from "react";

export interface AscAddActivityProps {
  className?: string;
  activityType: ActivityTypeSelectOptions["value"];
  order:number;
  activityAttempt: ActivityAttemptsSelectOptions["value"];
  onTypeChange?: (type: ActivityTypeSelectOptions["value"] | undefined) => void;
  onAttemptChange?: (
    attempt: ActivityAttemptsSelectOptions["value"] | undefined
  ) => void;
  selectableActivityTypes: ActivityTypeSelectOptions[];
}

function AscAddActivity({
  className,
  activityAttempt,
  activityType,
  onTypeChange,
  onAttemptChange,
  selectableActivityTypes,
}: AscAddActivityProps) {
  const formik = useAscAddModuleActivitiesForm();
  const editMode = useMemo(
    () => !!formik?.values?.[activityType]?.id,
    [formik?.values, activityType]
  );
  return (
    <div className={classNames(styles.ground, className)}>
      <div className={styles.form}>
        <div className={styles.fieldForm}>
          <label className={styles.fieldLabel} htmlFor="typeActivity">
            Type of activity
          </label>
          <AscSelectInput
            className={classNames(styles.inputField)}
            fullWidth={true}
            placeholder={
              editMode
                ? selectableActivityTypes?.find(
                    (t) => t?.value === activityType
                  )?.label
                : "Select type of activity"
            }
            id="typeActivity"
            name="typeActivity"
            value={activityType}
            onChange={onTypeChange}
            disabled={editMode}
          >
            {selectableActivityTypes?.map((option) => (
              <AscSelectInput.Option
                key={option.value}
                value={option.value}
                label={option.label}
              />
            ))}
          </AscSelectInput>
        </div>

        <div className={styles.fieldForm}>
          <label className={styles.fieldLabel} htmlFor="attemptsNum">
            Number of attempts
          </label>
          <AscSelectInput
            className={classNames(styles.inputField, {
              // [styles.errorInput]:
              //   formik.errors.attemptsNum && formik.touched.attemptsNum,
            })}
            fullWidth={true}
            placeholder="Select number of attempts"
            id="attemptsNum"
            name="attemptsNum"
            value={activityAttempt}
            onChange={onAttemptChange}
          >
            {ACTIVITY_ATTEMPTS_OPTIONS?.map((option) => (
              <AscSelectInput.Option
                key={option.value}
                value={option.value}
                label={option.label}
              />
            ))}
          </AscSelectInput>
        </div>
      </div>

      <AscActivitiesFactory type={activityType} />
    </div>
  );
}

export default AscAddActivity;
